module.exports = __webpack_public_path__ + "static/media/money.0b42a7d1.png";